import { url } from "../../src/Values/constants";
import {
    showSnackbarAction
} from "../Redux/actions";
import axiosHandler from "./axiosHandler";

export const getFBPages = async (
    userId: string,
    userAccessToken: string,
    setFbPagesList: any,
    setFbPagesData: any,
) => {
    try {
        const res = await axiosHandler.get(`https://graph.facebook.com/v26.0/${userId}/accounts?access_token=${userAccessToken}`);

        if (res.data.data.length > 0) {
            const pagesList = res.data.data.map((item: any) => ({
                label: item.name,
                value: item.id
            }));

            setFbPagesList(pagesList);
            setFbPagesData(res.data.data);
        }
    } catch (error: any) {
        console.log("error fetching fb pages", error);
    }
};

export const getFBForms = async (
    pageId: string,
    fbPagesData: any,
    setFbFormsList: any,
) => {
    try {
        const selectedPage = fbPagesData.find((item: any) => item.id === pageId);
        if (!selectedPage) return;

        const pageAccessToken = selectedPage.access_token;

        const res = await axiosHandler.get(`https://graph.facebook.com/v26.0/${pageId}/leadgen_forms?access_token=${pageAccessToken}`);

        if (res.data.data.length > 0) {
            const formsList = res.data.data.map((item: any) => ({
                label: item.name,
                value: item.id
            }));

            setFbFormsList(formsList);
        }
    } catch (error: any) {
        console.log("error fetching fb forms", error);
    }
};

export const createFBIntegration = async (
    fbPageSelected: any,
    fbPagesData: any,
    organization_id: string,
    integration_type: string,
    integration_name: string,
    integration_status: string,
    integration_mapped_fields: any,
    created_by: string,
    modified_by: string,
    fb_page_name: string,
    fb_form_name: string,
    dispatcher: any,
    setLoad: any,
    history: any,
    authToken: string,
    fbFormId: any,
    userAccessToken: any,
    fb_page_id: any
) => {
    try {
        setLoad(true);
        let pageId = fbPageSelected.value;
        let pageAccessToken:any;
        fbPagesData.map((item: any) => {
            if (item.id === pageId) {
                pageAccessToken = item.access_token;
            }
        })
        let apiData = {
            organization_id,
            integration_type,
            integration_name,
            integration_status,
            integration_mapped_fields,
            created_by,
            modified_by,
            fb_page_name,
            fb_form_name,
            fb_page_access_token:pageAccessToken,
            fb_form_id:fbFormId,
            fb_user_access_token:userAccessToken,
            fb_page_id,
        }
        const res = await axiosHandler.post(url + '/integrations/createIntegration', apiData);
        dispatcher(
            showSnackbarAction(res.data.message, "success")
        );
        setLoad(false);
        window.location.reload();
    } catch (error: any) {
        dispatcher(
            showSnackbarAction(error?.response?.data?.message ? error.response.data.message : "An error occured", "error")
        );
        setLoad(false);
    }
};

export const createGoogleSheetIntegration = async (
    organization_id: string,
    integration_type: string,
    integration_name: string,
    integration_status: string,
    integration_mapped_fields: any,
    google_sheet_url: string,
    google_sheet_name: string,
    google_sheet_id: string,
    google_sheet_batch_interval: string,
    created_by: string,
    modified_by: string,
    dispatcher: any,
    setLoad: any,
    setRefresh: (load: boolean) => void,
    history: any,
    authToken: string,
) => {
    try {
        setLoad(true);
        let apiData = {
            organization_id,
            integration_type,
            integration_name,
            integration_status,
            integration_mapped_fields,
            created_by,
            modified_by,
            google_sheet_url,
            google_sheet_name,
            google_sheet_id,
            google_sheet_batch_interval,
        }
        // axios.defaults.headers.common['x-access-token'] = authToken;
        const res = await axiosHandler.post(url + '/integrations/createIntegration', apiData);
        dispatcher(
            showSnackbarAction(res.data.message, "success")
        );
        console.log("res.data.message",res.data.message)
        if(res.data.message==="Integration created successfully")
        {
            setRefresh(true)
        }
        setLoad(false);
        // window.location.reload();
    } catch (error: any) {
        dispatcher(
            showSnackbarAction(error?.response?.data?.message ? error.response.data.message : "An error occured", "error")
        );
        setLoad(false);
    }
};

export const verifyGoogleSheetIntegration = async (
    organization_id: string,
    google_sheet_id: string,
    google_sheet_name:string,
    dispatcher: any,
    setLoad: any,
    setHeaders:any,
    setShowGiveAcess:any,
    setShowMapIntegrationForm:any,
    history: any,
    authToken: string,
) => {
    try {
        setLoad(true);
        let apiData = {
            organization_id,
            google_sheet_id,
            google_sheet_name
        }
        // axios.defaults.headers.common['x-access-token'] = authToken;
        const res = await axiosHandler.post(url + '/integrations/getGoogleSheetData', apiData);
        // console.log("res--verifyGoogleSheetIntegration",res)
        setHeaders(res.data.headers)
        // setShowGiveAcess(res.data.access)
        if(res.data.headers){setShowMapIntegrationForm(true)}
        dispatcher(
            showSnackbarAction(res.data.message, "success")
        );
        setLoad(false);
        
        // window.location.reload();
    } catch (error: any) {
        dispatcher(
            showSnackbarAction(error?.response?.data?.message ? error.response.data.message : "An error occured", "error")
        );
        if(error.response.data.errorCode == 403){
            setShowGiveAcess(true);
        }
        setLoad(false);
    }
};

export const fetchIntegrations = async (
    organization_id: string,
    setIntegrations: (data: any[]) => void,
    authToken: string,
    setCount: (data: any) => void,
    limit: any,
    page: any,
    setLoad: (load: boolean) => void,
    oldData: any,
    isFinished: any,
    setIsFinished: (load: boolean) => void,
    integration_type: string,
    integrationTypeNumber: Number,
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number,
    tempIsFinished?: boolean,
) => {
    try {
        //   if (isFinished === true && tempIsFinished !== false) {
        //     return;
        //   }
        //   let stringFilters: string = convertToFilterString(filters);
        let integrationsTableData: any[] = [];
        let records = localPageSize ? localPageSize : limit;
        let apiData: any = {
            organization_id: organization_id,
            integration_type: integrationTypeNumber === 0 ? "GOOGLE SHEET" : "FB LEADS",
            // sort:  Object.keys(sort).length === 0
            // ? { created_at: "-1" }
            // : sort,
            // filters: stringFilters,
            page: localPage ? localPage : page + 1,
            limit: localPageSize ? localPageSize : limit,
            // search: searchQuery
        };
        setLoad(true);
        // axios.defaults.headers.common['x-access-token'] = authToken;
        const res = await axiosHandler.get(url + '/integrations/fetchAll', {
            params: apiData,
        });
        let integrationsData = res.data.data.integrationsData;
        let integrationsCount = res.data.data.integrationsCount;
        integrationsData.map((integration: any) => {
            // console.log("integrationsTableData   API",integrationsTableData)
            if (integrationTypeNumber === 1) {
                integrationsTableData.push({
                    "Integration Name": integration.integration_name,
                    "FB Page": integration.fb_page_name,
                    "FB Form": integration.fb_form_name,
                    "Status": integration.integration_status,
                    "Created At": integration.created_at,
                    "Modified At": integration.modified_at,
                    "Created By": integration.created_by,
                    "Modified By": integration.modified_by,
                })
            } else {
                // console.log("integrationsTableData",integration)
                integrationsTableData.push({
                    "Integration Name": integration.integration_name,
                    "Sheet ID": integration.google_sheet_id,
                    "Sheet Name": integration.google_sheet_name,
                    "Status": integration.integration_status,
                    "Created At": integration.created_at,
                    "Modified At": integration.modified_at,
                    "Created By": integration.created_by,
                    "Modified By": integration.modified_by,
                    "Sheet URL":integration.google_sheet_url,
                    "Time Interval":integration.google_sheet_batch_interval
                })
            }
        })
        // console.log("data res api tokens", res.data.data, isFinished)
        // if ((page.currentValue < page.previousValue) || oldData.length ) {
        //   return;
        // }
        // console.log("resdata", integrationsData, integrationsCount);
        //   if (integrationsData.length < records) {
        //     setIsFinished(true);
        //   }

        setCount(integrationsCount);
        //   setLoad(false);
        //   if (paginate && oldData) {
        //     let newData = [...oldData, ...integrationsData];
        //     setIntegrations(newData);
        //     setLoad(false);
        //   } else {
        setIntegrations(integrationsTableData);
        setLoad(false);
        //   }
        // dispatcher(
        //   showSnackbarAction(res.data.message, "success")
        // );
        // setLoad(false);
        // close();
        // editClose();
    } catch (error: any) {
        // dispatcher(
        //   showSnackbarAction(error.response.data.message, "error")
        // );
        // setLoad(false);
        setLoad(false);
    }
};

export const deleteIntegration = async (
    integrationName: string,
    organization_id: string,
    dispatcher: any,
    setLoad: (data: boolean) => any,
    setModal: any,
) => {
    try {
        let apiData = {
            organization_id: organization_id,
            integration_name: integrationName
        }
        const res = await axiosHandler.post(url + '/integrations/delete', apiData);
        //   setLoad(false);
        setModal(false);
        dispatcher(
            showSnackbarAction(res.data.message, "success")
        );
        //   clearSelectedRowsData && clearSelectedRowsData();
        window.location.reload();
    } catch (error: any) {
        dispatcher(
            showSnackbarAction(error.response.data.message, "error")
        );
        //   setLoad(false);
        // console.log("Upload Error:", error);
    }
};


export const updateIntegration = async (
    integration_name: string,
    organization_id: string,
    updateData: any,
    dispatcher: any,
    setLoad: (data: boolean) => void,
    setModal?: any,
    // authToken: any,
    // history?: any,
) => {
    try {
        setLoad(true);
        let apiData = {
            data: updateData,
            organization_id,
            integration_name
        }
        // axios.defaults.headers.common['x-access-token'] = authToken;
        const res = await axiosHandler.post(url + '/integrations/update', apiData);
        dispatcher(showSnackbarAction(res.data.message, 'success'));
        setLoad(false);
        // setModal(false);
        window.location.reload();
    } catch (error: any) {
        dispatcher(
            showSnackbarAction(error.response.data.message, "error")
        );
        //   setLoad(false);
    }
};

export const getFBFormFields = async (
    integration_name: string,
    organization_id: string,
    setHeaders: any,
) => {
    try {
        let apiData = {
            organization_id,
            integration_name
        }
        // axios.defaults.headers.common['x-access-token'] = authToken;
        const res = await axiosHandler.post(url + '/integrations/getFBFormFields', apiData);
        setHeaders(res.data.data.formFields);
    } catch (error: any) {
        console.log("aman error",error);
    }
};
